<template>
  <section class="section-wrapp">
    <Breadcrumbs v-if="breadcrumbsData !== null" v-bind:parameters="breadcrumbsData"></Breadcrumbs>

    <section class="section-graph">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-lg-8">
            <div class="weather-graph-start">
              <highcharts :key="componentKey" :options="chartOptions"></highcharts>
            </div>
          </div>
          <div class="col-12 col-lg-4 inverters">
            <flat-pickr v-model="dataTime" :config="config" style="display: none;" name="date"></flat-pickr>
            <div style="width: 308px; margin-top: 24px;">
              <flat-pickr v-model="exportDate"
                :config="{ dateFormat: 'Y-m-d', mode: 'range', locale: { rangeSeparator: ' : ', firstDayOfWeek: 1 } }"
                name="date"></flat-pickr>
              <div class="export_container">
                <div class="export_select">
                  <select name="mode" id="" v-model="exportMode">
                    <option value="1">All</option>
                    <option value="2">By date</option>
                  </select>
                </div>
                <div class="export_btn_wr">
                  <div class="export_btn statistic-new-download" @click="exportCSV"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import DataAPI from '../../api/data.js';
import StationAPI from '../../api/station.js';
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import { Chart } from 'highcharts-vue'
// import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import graphConfigs from '@/components/graphConfigs'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/themes/dark.css'
// import 'flatpickr/dist/flatpickr.css'
import '../../assets/css/js-datapicer.css'
import moment from 'moment'
import _get from 'lodash/get'
import _forEach from 'lodash/forEach'
import _groupBy from 'lodash/groupBy'
import _uniq from 'lodash/uniq'
import _sortBy from 'lodash/sortBy'


// stockInit(Highcharts)

export default {
  name: 'Inverters',
  mixins: [graphConfigs],
  components: { Breadcrumbs, flatPickr, 'highcharts': Chart },
  data() {
    return {
      sample: null,
      station: null,
      breadcrumbsData: null,
      title: '',
      exportDate: null,
      exportMode: '1',
      config: {
        dateFormat: 'Y-m-d',
        inline: true,
        locale: {
          firstDayOfWeek: 1
        },
        onChange: (selectedDates) => {
          let dateTime = moment(selectedDates[0]).format('YYYY-MM-DD')
          this.fetchData(dateTime);
        }
      },
      dataTime: moment().format('YYYY-MM-DD'),
      componentKey: 0,
      chartOptions: {
        chart: {
          marginLeft: 60,
        },
        title: {
          text: 'Inverters daily production',
          style: {
            color: '#ffffff'
          }
        },
        tooltip: {
          formatter: function () {
            return '<span style="color:#f36f37;">' + this.point.name + '</span>' + ': ' + this.y + ' kWh';
          }
        },
        yAxis: {
          labels: {
            style: {
              color: '#ffffff'
            }
          },
          gridLineColor: '#595c5e',
          title: {
            style: {
              color: '#ffffff'
            },
            text: 'Production, kWh'
          }
        },
        xAxis: {
          labels: {
            style: {
              color: '#ffffff'
            }
          }
        }
      },
      devices: null,
      deviceMap: null
    }
  },
  created() {
    let id = this.$route.params.id

    StationAPI.fetchDevices(id).then(r => {
      this.devices = r.data['11'];
      this.fetchData(this.dataTime);

      let deviceMap = new Map();

      let devices = this.devices.map(d => {
        let match = d.name.match(/(\d+)\.(\d+)/);
        // console.log(match);
        d.ktpNumber = Number(match[1]);
        d.innerNumber = Number(match[2]);

        return d;
      });

      devices = _sortBy(devices, ['ktpNumber', 'innerNumber']);

      devices.forEach((d, index) => {
        d.index = index + 1;
        deviceMap.set(d.id, d)
      });

      this.deviceMap = deviceMap;
    });

    this.$store.dispatch('station/findOne', id).then((station) => {
      this.station = station

      this.breadcrumbsData = [
        {
          url: '/station-view/' + station.id,
          title: station.title
        },
        {
          url: '#',
          title: station.title + ' (Grid inverters)'
        }
      ]
      this.title = station.title + ' (' + station.totalPower + ' MW)'
    }).catch(e => {
      console.log('Got transfer error: ' + e.message)
    });
  },
  methods: {
    forceRerender() {
      this.componentKey += 1
    },
    exportCSV() {
      let id = this.$route.params.id;

      let match;
      let from;
      let to;

      if (match = this.exportDate.match(/(\d{4}-\d{2}-\d{2})\s\:\s(\d{4}-\d{2}-\d{2})/)) {
        from = match[1];
        to = match[2];
      } else if (match = this.exportDate.match(/(\d{4}-\d{2}-\d{2})/)) {
        from = match[1];
        to = match[1];
      }

      DataAPI.invertersProduction(id, from, to).then(r => {
        let csv = this.getExportData(r.data, this.deviceMap);

        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = 'inverters_production_' + moment().format('YYYY-MM-DD_hh:mm:ss') + '.csv';
        anchor.click();
      });
    },
    getExportData(data, deviceMap) {
      data = data.map(line => {
        let inv = deviceMap.get(line.device_id);
        line.index = inv.index;

        return line;
      });

      data = _sortBy(data, ['time', 'index']);

      if (this.exportMode == '2') {
        return this.exportGroupedData(data, deviceMap);
      } else {
        return this.exportAllData(data, deviceMap);
      }
    },
    exportAllData(data, deviceMap) {
      let csv = 'Date;Device;Production;Device #\n';
      data.map(line => {
        let time = moment(line.time, 'YYYY-MM-DD hh:mm:ss').format('YYYY-MM-DD');

        let inv = deviceMap.get(line.device_id);
        // let name, number = line.device_id;
        // if (deviceMap.has(name)) {
        let name = inv.name;
        let number = inv.index;
        // }

        let production = String(line.production).replace('.', ',');

        return [time, name, production, number]
      }).forEach((row) => {
        csv += row.join(';');
        csv += "\n";
      });

      return csv;
    },
    exportGroupedData(data, deviceMap) {
      // moment(val.time, 'YYYY-MM-DD hh:mm:ss').format('YYYY-MM-DD')
      let dates = _uniq(data.map(val => val.time))

      let result = _groupBy(data, function (item) {
        return item.device_id;
      });

      _forEach(result, function (value, key) {
        result[key] = _groupBy(value, function (item) {
          return item.time;
        });
      });

      let rows = [['Device #', 'Name', ...dates.map(d => moment(d, 'YYYY-MM-DD hh:mm:ss').format('YYYY-MM-DD'))]];

      _forEach(result, (value, key) => {
        let name = Number(key);
        let number;
        if (deviceMap.has(name)) {
          number = deviceMap.get(name).index;
          name = deviceMap.get(name).name;
        }

        let row = [number, name];

        _forEach(dates, (date) => {
          let production = _get(value, `[${date}][0][production]`, null);
          if (production) {
            production = String(production).replace('.', ',');
          }

          row.push(production);
        });

        rows.push(row);
      });

      let csv = '';

      rows.forEach((row) => {
        csv += row.join(';');
        csv += "\n";
      });

      return csv;
    },
    parseData() {
      let dataset = [];

      // Daily_energy
      this.devices.forEach(d => {
        let val = _get(this.sample, `[${d.id}][Daily_energy]`, null);
        let number = this.deviceMap.get(d.id).index;

        let convertedValue = Number(val);
        convertedValue = Math.round(convertedValue * 100) / 100

        dataset.push({
          x: number,
          y: convertedValue,
          name: d.name
        });
      });

      this.chartOptions.series = [
        {
          type: 'scatter',
          name: 'Inverters',
          data: dataset,
          marker: {
            radius: 4
          }
        }
      ];
      this.forceRerender();
    },
    fetchData(date) {
      let id = this.$route.params.id

      if (moment().format('YYYY-MM-DD') === date) {
        StationAPI.lastData(id).then(r => {
          this.sample = r.data;
          this.parseData();
        });
      } else {
        DataAPI.dateTimeData(id, date + ' 23:00:00').then(r => {
          this.sample = r.data;
          this.parseData();
        });
      }
    }
  },
}
</script>

<style>
.inverters .flatpickr-day {
  color: white
}

.flatpickr-days .flatpickr-day {
  color: white
}

.inverters .flatpickr-calendar {
  box-shadow: none;
}

.export_container {
  display: flex;
  float: left;
  width: 100%;
  align-items: end;
}

.export_select {
  flex: 1;
}

.export_btn_wr {
  width: 54px;
  margin-left: 12px;
}

.export_btn_wr .statistic-new-download::before {
  left: 12px;
}

.export_btn {
  background-color: #f36f37;
  width: 100%;
  height: 44px;
  border-radius: 4px;
}
</style>
